import { render, staticRenderFns } from "./ChatTopMessage.vue?vue&type=template&id=93d97cb0&scoped=true"
import script from "./ChatTopMessage.vue?vue&type=script&lang=js"
export * from "./ChatTopMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatTopMessage.vue?vue&type=style&index=0&id=93d97cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d97cb0",
  null
  
)

export default component.exports